import React, { useState } from 'react';
import { Share2, Check } from 'lucide-react';

/**
 * Copies permalink /ask-ai/:id (same content as /ask/:id).
 */
export default function ShareIdeaRow({ questionId }) {
  const [copied, setCopied] = useState(false);
  if (!questionId) return null;

  const url =
    typeof window !== 'undefined'
      ? `${window.location.origin}/ask-ai/${questionId}`
      : `/ask-ai/${questionId}`;

  const onShare = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      // ignore
    }
  };

  return (
    <div className="flex items-center gap-2 pt-3 border-t border-gray-100">
      <button
        type="button"
        onClick={onShare}
        className="inline-flex items-center gap-2 text-sm text-gray-500 hover:text-gray-800 transition-colors"
      >
        {copied ? (
          <Check className="w-4 h-4 text-green-600 flex-shrink-0" style={{ width: 16, height: 16 }} aria-hidden />
        ) : (
          <Share2 className="w-4 h-4 flex-shrink-0 text-gray-400" style={{ width: 16, height: 16 }} aria-hidden />
        )}
        {copied ? 'Link copied' : 'Share this idea'}
      </button>
    </div>
  );
}
